import { makeAutoObservable } from 'mobx';

export default class TextFilter {

    text: string = '';

    constructor() {
        this.text = '';
        makeAutoObservable(this);
    }

    changeSearchText(value: string): void {
        this.text = value;
    }
}